import _get from "lodash/get.js";
import { getAccommodation, getAccommodationLiteralsFromOldData } from "../../../../../helpers/common/searchers/index.js";
const oldTypeToNewType = {
    airport: 'AER',
    island: 'ISL',
    city: 'CIU',
    zone: 'ZON',
    hotel: 'HOT'
};
const getConfig = (oldModel)=>{
    const accommodationLiterals = getAccommodationLiteralsFromOldData(oldModel);
    const config = {
        literals: {
            ...accommodationLiterals,
            originLabel: _get(oldModel, 'location.items[0].input.label.content', ''),
            destinationLabel: _get(oldModel, 'location.items[1].input.label.content', ''),
            calendarLabel: _get(oldModel, 'calendar.input.label.content', ''),
            classesLabel: '',
            CIU: '',
            AER: '',
            HOT: '',
            PUE: '',
            ISL: '',
            ZON: '',
            loadingTitle: _get(oldModel, 'loading.Body.Loading.title.content', ''),
            loadingMessage: _get(oldModel, 'loading.Body.Loading.message.content', ''),
            submit: _get(oldModel, 'submit.content', ''),
            legent: _get(oldModel, 'config.data.literal.legentDirectFlight', _get(oldModel, 'calendar.Footer.directFlight', '')),
            checkIn: _get(oldModel, 'calendar.literals.origin', ''),
            checkOut: _get(oldModel, 'calendar.literals.destination', ''),
            locationTitle: _get(oldModel, 'location.literals.modalHeaderTitle', ''),
            checkInLabel: _get(oldModel, 'calendar.literals.modalHeaderTitle', ''),
            tabContentOrigin: _get(oldModel, 'location.literals.placeholderOrigin', ''),
            tabContentDestination: _get(oldModel, 'location.literals.placeholderDestination', ''),
            calendarTitle: _get(oldModel, 'calendar.literals.modalHeaderTitle', ''),
            yearLabel: '',
            yearsLabel: '',
            accept: _get(oldModel, 'calendar.literals.modalFooterSubmit', _get(oldModel, 'location.literals.modalFooterSubmit', _get(oldModel, 'vehicle.panel.Footer.action.items[0].content', accommodationLiterals.accept))),
            labelDiscountsByDefault: _get(oldModel, 'discount.config.data.items[0].label', _get(oldModel, 'discounts.data.config.data.items[0].label', _get(oldModel, 'discounts.props.config.data.items[0].label', ''))),
            deleteLabel: ''
        },
        endpoints: {},
        releaseDays: 2,
        hasDiscounts: true,
        disableDates: true,
        onModal: _get(oldModel, 'config.onModal', false),
        hideDestination: _get(oldModel, 'config.hideDestination', false),
        params: {
            productType: 'FlightHotel',
            LineOfBusiness: 'Packages',
            hotelCode: oldModel?.config?.hotelCode
        }
    };
    return config;
};
const getNewType = (oldType)=>{
    if (oldType in oldTypeToNewType) {
        return oldTypeToNewType[oldType];
    }
    return oldType;
};
const getOrigin = (oldModel)=>{
    const originTypes = _get(oldModel, 'location.items[0].config.provider.types', [
        'airport'
    ]);
    const origin = {
        value: _get(oldModel, 'location.items[0].value.value'),
        text: _get(oldModel, 'location.items[0].value.content'),
        type: getNewType(_get(oldModel, 'location.items[0].value.type', 'AER')),
        types: originTypes ? originTypes.map((type)=>oldTypeToNewType[type]) : [
            'AER'
        ],
        limit: _get(oldModel, 'location.items[0].config.provider.limit', 20)
    };
    return origin;
};
const getDestination = (oldModel)=>{
    const destinationTypes = _get(oldModel, 'location.items[1].config.provider.types', [
        'island',
        'city',
        'zone',
        'hotel'
    ]);
    const destination = {
        value: _get(oldModel, 'location.items[1].value.value'),
        text: _get(oldModel, 'location.items[1].value.content'),
        type: getNewType(_get(oldModel, 'location.items[1].value.type', destinationTypes[0])),
        types: destinationTypes ? destinationTypes.map((type)=>oldTypeToNewType[type]) : [
            'ISL',
            'CIU',
            'ZON',
            'HOT'
        ],
        limit: _get(oldModel, 'location.items[1].config.provider.limit', 20)
    };
    return destination;
};
const getDates = (oldModel)=>{
    const defaultDates = _get(oldModel, 'calendar.config.data.defaultDates', []);
    const dates = {
        startDate: defaultDates[0],
        endDate: defaultDates[1],
        minDate: 'today',
        sameDay: true,
        releaseDays: _get(oldModel, 'calendar.config.data.releaseDays', 1)
    };
    return dates;
};
const transformOldModelToNewModel = (oldModel)=>({
        config: getConfig(oldModel),
        origin: getOrigin(oldModel),
        destination: getDestination(oldModel),
        dates: getDates(oldModel),
        accommodation: getAccommodation(oldModel)
    });
export const transformOldModelToNewModelDesktop = (oldModel)=>transformOldModelToNewModel(oldModel);
export const transformOldModelToNewModelMobile = (oldModel)=>transformOldModelToNewModel(oldModel);
export const getTransformedPropsIfNeeded = (props)=>{
    if (props?.config && 'literals' in props.config) return props;
    return transformOldModelToNewModelDesktop(props);
};
export const getTransformedPropsIfNeededMobile = (props)=>{
    if (props?.config && 'literals' in props.config) return props;
    return transformOldModelToNewModelMobile(props);
};

//# sourceMappingURL=model.js.map